var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home flex-1 overflow-hidden",staticStyle:{"width":"100%"}},[_c({
      name: 'dynamic-content',
      template: this.contentTemplate,
    },{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }